import { render, staticRenderFns } from "./CategoryDashboard.vue?vue&type=template&id=7adfeaf8&"
import script from "./CategoryDashboard.vue?vue&type=script&lang=js&"
export * from "./CategoryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports